module.exports = __webpack_public_path__ + "static/img/app-link.968dc75.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/app-link.jpg
// module id = VB/g
// module chunks = 1